module.exports = __webpack_public_path__ + "img/17619009000188.26bd7c03.png";